module.exports = __webpack_public_path__ + "img/j1.662d467d.png";